import { useState } from "react";

export type BeforeAfterMode = "with" | "without";

// The before/after timeline shows one of two stories at a time. The only
// state is which one; everything else (line fill, card styles, summary) is
// derived from it during render.
export function useBeforeAfter(initialMode: BeforeAfterMode = "with") {
  const initialState = { mode: initialMode };
  const [state, setState] = useState(initialState);

  const setMode = (mode: BeforeAfterMode) =>
    setState((state) => ({ ...state, mode }));

  return { mode: state.mode, isWithout: state.mode === "without", setMode };
}
